<ng-container *ngIf="weekDayHeader$ | async as headerData">
  <div
    fxLayout="column"
    [ngClass]="{
      'day-today': headerData.isToday,
      'day-past': headerData.isPast
    }"
  >
    <div class="week-day-of-week">
      {{ headerData.dayOfWeek }}
    </div>

    <a
      class="week-date"
      queryParamsHandling="merge"
      [routerLink]="[]"
      [queryParams]="headerData.queryParams"
    >
      {{ headerData.dayOfMonth }}
    </a>

    <ng-container *ngIf="events$ | async as events">
      <div
        class="calendar-events-wrapper"
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxLayoutGap="3px"
      >
        <pr-calendar-event
          *ngFor="let event of events; let i = index; trackBy: trackByEvent"
          fxFlex
          [index]="i"
          [event]="event"
          [day]="headerData.day"
         />
      </div>
    </ng-container>
  </div>
</ng-container>
